import { css } from "@emotion/css"

export const itemStyles = {
  container: css`
    border: 1px solid var(--light-grey-2);
    background-color: var(--light-grey-2);
    border-radius: var(--spacing-xxs);
    padding: var(--spacing-m) var(--spacing-xs);
    padding-right: var(--spacing-s);
    margin: var(--spacing-xs) 0;
    justify-content: space-between;
    width: 100%;
    max-width: 305px;
  `,
  delContainer: css`
    border: 1px solid var(--red);
    border-radius: var(--spacing-xxs);
    background-color: var(--lighter-red);
    padding: var(--spacing-s);
    padding-left: var(--spacing-xs);
    margin: var(--spacing-xs) 0;
    justify-content: space-between;
    width: 100%;
  `,
  row: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 100%;
  `,
  column: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    overflow: hidden;
  `,
  image: css`
    width: var(--spacing-xl);
    height: var(--spacing-xl);
    margin-right: 0.5rem;
  `,
  name: css`
    white-space: nowrap;
    max-width: 95%;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 2px;
  `,
  button: css`
    max-width: fit-content;
    > button {
      padding: var(--spacing-xs);
    }
  `,
  delName: css`
    white-space: nowrap;
  `,
  details: css`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 95%;
  `,
  description: css`
    text-align: left;
    margin-top: 0.5rem;
  `,
  delContainerRow: css`
    display: flex;
    align-items: flex-start;
    width: 100%;
    overflow: hidden;
  `,
  buttonGroup: css`
    display: flex;
    margin-left: var(--spacing-m);
  `,
}
